import { Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

import Login from "./pages/Login";
import GuestDashboard from "./pages/GuestDashboard";
import TableManagement from "./pages/TableManagement";
import MessageTemplates from "./pages/MessageTemplates";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route path="/guests" element={<GuestDashboard />} />
      <Route path="/tables" element={<TableManagement />} />
      <Route path="/messages" element={<MessageTemplates />} />
    </Routes>
  );
}

export default App;
